import PageBannerCard from '@shared/components/core/card/PageBannerCard';
import OrganizationMemberRole from '@shared/models/organizations/OrganizationMemberRole';
import { useTranslation } from 'react-i18next';
import InviteCreateAccess from './InviteCreateAccess';

export interface IInviteEmptyBannerProps {
    myRole?: OrganizationMemberRole;
    organizationId: string;
}

export default function InviteEmptyBanner({ myRole, organizationId }: IInviteEmptyBannerProps) {
    const { t } = useTranslation();

    return (
        <PageBannerCard
            description={t('common:organization.invite.noInvites.description')}
            fullHeight
            icon="orgCompany"
            title={t('common:organization.invite.noInvites.title')}>
            {myRole && organizationId && <InviteCreateAccess organizationId={organizationId} myRole={myRole} />}
        </PageBannerCard>
    );
}
